import { useCallback, useEffect, useState } from "react";

import { IDropdownOption } from "@treelab/panda";

interface ISortOption extends IDropdownOption {
  image?: string;
  color?: string;
}

interface ICollOptionsSort {
  options: ISortOption[];
  selected: string[] | null;
  isCurrentFirst?: boolean;
  currentUserId?: string;
  getOptionId: (option: ISortOption) => string;
}

export const collaboratorOptionsSort = ({
  options,
  selected,
  isCurrentFirst,
  currentUserId,
  getOptionId,
}: ICollOptionsSort) => {
  const selectedOptions: ISortOption[] = [];
  const unSelectedOptions: ISortOption[] = [];

  options.forEach((item) => {
    const itemId = getOptionId(item);
    const itemIsSelected = (selected || []).includes(itemId);
    if (isCurrentFirst && itemId === currentUserId) {
      itemIsSelected ? selectedOptions.unshift(item) : unSelectedOptions.unshift(item);
    } else {
      itemIsSelected ? selectedOptions.push(item) : unSelectedOptions.push(item);
    }
  });

  return [...selectedOptions, ...unSelectedOptions];
};

interface IProps {
  basicOptions: IDropdownOption[];
  selectedIds: string[];
  isUpdateOptions: boolean;
  isCurrentFirst?: boolean;
  currentUserId?: string;
}

/**
 * 适用于 Collaborator Options 排序
 * 规则1 如果 options 中包含 当前用户 则当前用户放在第一位
 * 规则2 已选择的 option 在 未选择的 option 前面
 * 规则2 优先级高于 规则1
 * dropdown 打开时不进行排序 所以需要 isUpdateOptions
 * @param payload
 * @returns
 */
const useSortCollaboratorOptions = (payload: IProps) => {
  const { basicOptions, selectedIds, isUpdateOptions, isCurrentFirst, currentUserId } = payload;

  const [collaboratorOptions, setCollaboratorOptions] = useState<IDropdownOption[]>(basicOptions);

  const sortFunc = useCallback(
    (list: IDropdownOption[]) => {
      return collaboratorOptionsSort({
        options: list,
        selected: selectedIds,
        getOptionId: (item: IDropdownOption) => item.value,
        isCurrentFirst,
        currentUserId,
      });
    },
    [selectedIds, isCurrentFirst, currentUserId]
  );

  useEffect(() => {
    if (!isUpdateOptions) return;
    const newOptions = sortFunc(basicOptions);
    setCollaboratorOptions(newOptions);
  }, [isUpdateOptions, basicOptions, sortFunc]);

  return [collaboratorOptions];
};

export default useSortCollaboratorOptions;
